import { Settings } from "lucide-react";
import { ClientSettingsService } from "../modules";
import { openOAuth2Popup } from "./ory-popup";
import { getAppSettings } from "../../hooks/settings/settings";
import { UserCache } from "../caches";


export class OryAuthenticationService {

    public static async oryConfig() {
        let service = new ClientSettingsService();
        return await service.oryConfig();

    }

    public async login() {

        let config = await OryAuthenticationService.oryConfig();
        const clientId = config.clientId;
        const authEndpoint = `${config.identity}/oauth2/auth`;
        const scope = "openid profile email";
        const redirectUri = `${window.location.origin}`;

        const result = await openOAuth2Popup({
            authEndpoint,
            clientId,
            scope,
            redirectUri,
            // optional provider params:
            // extraParams: { prompt: "consent", access_type: "offline", audience: "..." }
        });

        //console.log('Ory OAuth2 popup result:', result);

        if (!result.ok) {
            // Handle: PopupBlocked | PopupClosed | Timeout | StateMismatch | MissingCode | provider error
            throw new Error(`Ory popup failed: ${result.error}`);
        }



        let settings = getAppSettings()

        const authUrl = `${settings.fabrixServer}/auth/ory`;

        const resp = await fetch(authUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                code: result.code,
                code_verifier: result.codeVerifier,
            }),
        });

        if (!resp.ok) {
            const text = await resp.text();
            throw new Error(text || `HTTP ${resp.status}`);
        }

        const tokensOrSession = await resp.json();
      //  console.log('Ory tokens/session:', tokensOrSession);

        if (tokensOrSession)
            UserCache.idToken = tokensOrSession.access_token;


        return tokensOrSession;
    }

}